<template><svg viewBox="0 0 2 16" xmlns="http://www.w3.org/2000/svg"><path d="M0 4h2v12H0zM0 0h2v2H0z"/></svg></template>